/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { B2BUser, RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentItemService } from '../../../../shared/current-item.service';
import {B2BUserService} from "../../../../../core/services";
import {ROUTE_PARAMS} from "../../../../../root/route-params";

@Injectable({
  providedIn: 'root',
})
export class CurrentUnitUserService extends CurrentItemService<B2BUser> {
  constructor(
    protected routingService: RoutingService,
    protected b2bUserService: B2BUserService
  ) {
    super(routingService);
  }

  getDetailsRoute(): string {
    return 'orgUnitUserList';
  }

  protected getParamKey() {
    return ROUTE_PARAMS.userCode;
  }

  protected getItem(customerId: string): Observable<B2BUser> {
    return this.b2bUserService.get(customerId);
  }

  getError(code: string): Observable<boolean> {
    return this.b2bUserService.getErrorState(code);
  }
}
